import React, { createContext, useState, useMemo, useEffect } from 'react';


const TempContext = createContext({ temp: {}, setTemp: () => { } });

let activedata = JSON.parse(localStorage.getItem('temp'));
const TempContextProvider = ({ children }) => {
    const [temp, setTemp] = useState(activedata ? activedata : null);

    useEffect(()=>{
        localStorage.setItem("temp", JSON.stringify(temp));
    }, [temp]);

    const value = useMemo(() => ({ temp, setTemp }), [temp]);
    return (<TempContext.Provider value={value}>{children}</TempContext.Provider>);
};

const TempContextConsumer = TempContext.Consumer;
export { TempContext, TempContextProvider, TempContextConsumer };